import type { ComponentProps } from 'react';
import { cn } from '@/lib/macondo';

export function Card({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('bg-surface-primary border-border-primary rounded-card-sm border', className)} {...props} />;
}

/** A section with a visible heading, wired for screen readers. */
export function Section({ title, id, actions, children, className }: { title: string; id: string; actions?: React.ReactNode; children: React.ReactNode; className?: string }) {
  return (
    <section aria-labelledby={id} className={className}>
      <div className="mb-300 flex items-center justify-between gap-300">
        <h2 id={id} className="text-headline text-typography-primary">
          {title}
        </h2>
        {actions}
      </div>
      {children}
    </section>
  );
}
